import React from 'react'
import {  
    Button,
    Stack,
} from '@mui/material'
import Title from './Title'
import Paragraph from './Paragraph'
import { Link } from 'react-router-dom'

const GetInTouch = () => {
  var md= 800;
  var w = ('90%');
    return (

        
        <Stack 
        component='section'
        direction="column"
        minWidth='300px'
        width= '90%'
        paddingTop='200px'
        paddingBottom='100px'
        justifyContent= 'center'
        alignItems='center'
        marginBottom={'20px'}
        marginTop={'200px'}
        sx={{
            py: '100px',
            mx: 6,
            maxWidth: '800px',
            margin:'0px auto'
            
        }}
        >
            <Title 
            text={
                'We Bring Light To Basements'
                } 
            fontFamily={'League Spartan sans-serif'}
            textAlign={'left'}
            sx={{marginBottom: '40px'}}
            />

            
            <Paragraph 
            text={
                'When it comes to creating a safe and comfortable living space in your basement, egress windows are a must-have. Not only do they provide an escape route in case of an emergency, but they also allow natural light and fresh air to flow into the otherwise dark and stuffy space'
            }
            maxWidth = {md}
            mx={0}
            textAlign={'left'}
            sx ={{color:'#121212'}}
            />
            <Paragraph 
            text={
                'If you are planning to use your basement as a bedroom, it is \
                especially important to install an egress window. Building codes\
                 require that all basement bedrooms have at least one egress window that meets specific size\
                  and height requirements. This ensures that occupants can quickly and easily escape in case of a\
                   fire or other emergency.'
            }
            width = {w}
            maxWidth = {md}
            mx={0}
            textAlign={'left'}
            />
            <Paragraph 
            text={
                'But egress windows do more than just meet building code requirements. They also bring a host of benefits to basement bedrooms, including the benefit of natural light. Natural light has been shown to improve mood, increase productivity, and even enhance sleep quality. With an egress window in your basement bedroom, you \
                will be able to enjoy the benefits of natural light\
                 throughout the day, making your living space more inviting and comfortable.'
            }
            width = {w}
            maxWidth = {md}
            mx={0}
            textAlign={'left'}
            />
            <Paragraph 
            text={
                'At Jackson Egress Windows, we specialize in providing high-quality egress windows that meet building code requirements and exceed your expectations. Our team of experts can help you choose the right window for your basement bedroom and ensure that it is\
                 installed safely and efficiently.\
                  Contact us today to learn more about \
                  the benefits of egress windows for basement bedrooms and to schedule a consultation.'
            }
            width = {w}
            maxWidth = {md}
            mx={0}
            textAlign={'left'}
            />
            <Button component={Link} 
            to={'/contact'}
            variant="contained" 
            type="submit"
            size="large"
            sx= {{ 
                fontSize: '0.9rem',                
                padding: '8px',
                width: '300px', 
                height: '56px',              
                px: 4,
                mt: 3, 
                mb: 2,
                borderRadius: 1,
                backgroundColor: '#4dc548',
                "&:hover": {
                    backgroundColor: '#0deb2a',
                }
            }}
            >
                Get Quote
            </Button>
 
        </Stack>
    )
}

export default GetInTouch;